export default class {
    constructor(hour, minute) {
        this.hour = hour;
        this.minute = minute;
    }

    getHour() {
        return this.hour.value;
    }

    getMinute() {
        return this.minute.value;
    }

    minutesFromStartOfDay() {
        return this.getHour() * 60 + this.getMinute();
    }

    isMidnight() {
        return this.getHour() == 24;
    }
}
